import { CommonLayout } from '../commonComponents';
import {
    Route,
    Switch,
    useRouteMatch
} from 'react-router-dom';
import OrderEntry from './orderEntry';
import OrderDashboard from './orderDashboard';


const routerList = [
    {
        name: 'Order Dashboard',
        path: "order-dashboard",
        component: OrderDashboard,
    },
    {
        name: 'Order Entry',
        path: "order-entry",
        component: OrderEntry,
    }
]

function OrderManagementRoutes(): JSX.Element {
    const { path } = useRouteMatch();

    return (
        <Switch>
            {
                routerList.map((item, index) => (
                    <Route
                        exact
                        key={index}
                        path={`${path}/${item.path}`}
                        component={item.component}
                    />
                ))
            }
        </Switch>
    );
}
export default function OrderManagementRouter(): JSX.Element {
    return (
        <>
            <CommonLayout>
                <OrderManagementRoutes />
            </CommonLayout>
        </>
    )
}